import router from '@/router'
import store from '@/store'
import { tongyishenfen } from '@/api/loginApi'
// import { getToken } from '@/utils/auth' // 获取令牌

const whiteList = ['/login', '/bigscreen', '/oauth', '/login1'] // 白名单
// to  （进入的页面） 下一个页面  form 上一个页面（离开之前的页面）
// next() 不带参说明进入下一个页面（to） 不会执行router.beforeEach  带参数会执行router.beforeEach
router.beforeEach(async (to, from, next) => {
  // const hasToken = getToken() // 获取令牌
  // debugger
  const hasToken = localStorage.getItem('token')
  if (hasToken) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      const hasRoles = store.getters.roles && store.getters.roles.length > 0
      if (hasRoles) {
        // 解决首次加载不出路由的问题
        if (to.fullPath === '/home' || to.fullPath === '/screen') {
          const { roles } = await store.dispatch('user/getInfo')
          const accessRoutes = await store.dispatch('permission/generateRoutes', roles)
          accessRoutes.forEach((item: any) => {
            router.addRoute(item)
          })
          // console.log(router.getRoutes(), '查看现有路由')
          next()
        } else {
          next()
        }
      } else {
        const { roles } = await store.dispatch('user/getInfo')
        if (roles === undefined) {
          localStorage.clear()
        }
        const accessRoutes = await store.dispatch('permission/generateRoutes', roles)
        accessRoutes.forEach((item: any) => {
          router.addRoute(item)
        })
        // 静态路由
        // console.log(router.getRoutes(), '查看现有路由')
        next({ ...to, replace: true })
      }
    }
  } else {
    // has no token
    // if (whiteList.indexOf(to.path) !== -1) { // 存在   indexOf判断数组中是否有值  不存在返回-1
    //   next()
    // } else {
    //   next('/login')
    // }
    if (whiteList.includes(to.path)) { // 使用includes替代indexOf，更简洁
      next()
    } else {
      // const redirectUrl = config.redirectUrl // 假设登录后重定向回登录页面
      // const appId = config.appId // 你需要从某处获取这个
      // const authUrl = buildAuthUrl(appId, redirectUrl)
      // console.log(authUrl)
      // window.location.href = authUrl
      // const res: any = await tongyishenfen()
      // console.log(res.data[0])
      // window.location.href = res.data[0]
      next('/login')
    }
  }
})

router.afterEach(() => {
  // console.log('121')
})
